const SEEN_STORAGE_KEY_PREFIX = '__partner360-'
const SEEN_STORAGE_KEY_SUFFIX = '-seen'
const SEEN_VALUE = 'viewed'

const getSeenStorageKey = (tourId: string) =>
  `${SEEN_STORAGE_KEY_PREFIX}${tourId}${SEEN_STORAGE_KEY_SUFFIX}`

export const isWidgetTourSeen = (tourId: string): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    return window.localStorage.getItem(getSeenStorageKey(tourId)) === SEEN_VALUE
  } catch {
    return false
  }
}

export const markWidgetTourSeen = (tourId: string): void => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.localStorage.setItem(getSeenStorageKey(tourId), SEEN_VALUE)
  } catch {
    // A denied or full storage must not prevent the tour from opening.
  }
}

export const clearWidgetTourSeen = (tourId: string): void => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.localStorage.removeItem(getSeenStorageKey(tourId))
  } catch {
    // A denied storage must not break an explicit tour reset.
  }
}
